import type { TOC } from '@ember/component/template-only';
import { PrismCard } from '@mylighthouse/prism-ember';

export interface MarketSnapshotsCardSignature {
  Args: {
    showFooter: boolean;
  };
  Blocks: {
    content: [];
    footer: [];
  };
}

// PrismCard renders its footer wrapper whenever a `:footer` block is passed,
// even an empty one, so the footer block is only passed when it is needed.
const MarketSnapshotsCard: TOC<MarketSnapshotsCardSignature> = <template>
  {{#if @showFooter}}
    <PrismCard @contentLayout="noPadding" class="overflow-hidden">
      <:content>{{yield to="content"}}</:content>
      <:footer>{{yield to="footer"}}</:footer>
    </PrismCard>
  {{else}}
    <PrismCard @contentLayout="noPadding" class="overflow-hidden">
      <:content>{{yield to="content"}}</:content>
    </PrismCard>
  {{/if}}
</template>;

export default MarketSnapshotsCard;
